import IField from "@/interfaces/IField";
import FieldTypeEnum from "@/enums/fields/FieldTypeEnum";

/** Classe de base de tout type de champ */
abstract class BaseField implements IField {
	/** Type du champ */
	private _type: FieldTypeEnum;

	constructor (type: FieldTypeEnum) {
		this._type = type;
	}

	/** Type du champ */
	public get Type(): FieldTypeEnum {
		return this._type;
	}

	/** Type du champ */
	public set Type(value: FieldTypeEnum) {
		this._type = value;
	}
}

export default BaseField;